import {useCallback} from "react";
import {LoginProps} from "../types/authority";
import {getLocalStorage} from "../util/storage";

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}


interface EventBaseProps {
    board_id: string,
    user_name?: string,
    uid?: string,
    time?: Date
}

interface DownloadContentProps extends EventBaseProps{
    link: string,
    cart_id: string,
    cart_type: string
}

interface UploadImageProps extends EventBaseProps{
    src: string[]
}

interface InputRequestProps extends EventBaseProps {
    prompt: string
}

export const useGaEvents = () => {

    const useInfoStr = getLocalStorage('userInfo');
    const localUserInfo = useInfoStr ? JSON.parse(useInfoStr) as LoginProps : null;


    const sentDownloadContentEvent = useCallback((props: DownloadContentProps) => {
        window.gtag('event', 'download_content', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentOpenCanvasEvent = useCallback((props: EventBaseProps) => {
        window.gtag('event', 'open_canvas', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentExitCanvasEvent = useCallback((props: EventBaseProps) => {
        window.gtag('event', 'exit_canvas', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentUploadImageEvent = useCallback((props: UploadImageProps) => {
        window.gtag('event', 'upload_image', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentCreateCanvasEvent = useCallback((props: EventBaseProps) => {
        window.gtag('event', 'create_canvas', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentDeleteCanvasEvent = useCallback((props: EventBaseProps) => {
        window.gtag('event', 'delete_canvas', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    const sentInputRequestEvent = useCallback((props: InputRequestProps) => {
        window.gtag('event', 'input_request', {
            user_name: localUserInfo?.userName,
            uid: localUserInfo?.uuid,
            time: new Date(),
            ...props
        });
    }, []);

    return {
        sentDownloadContentEvent,
        sentOpenCanvasEvent,
        sentExitCanvasEvent,
        sentUploadImageEvent,
        sentCreateCanvasEvent,
        sentDeleteCanvasEvent,
        sentInputRequestEvent
    };
};